import React, { useState } from "react";
import { apiRequest } from "../utils/api";
import { useAlert } from '../components/AlertModal';
import "../styles/AddPF.css";

function AddProductForm() {
    const { showAlert } = useAlert();
    const [formData, setFormData] = useState({
        item_name: "",
        sku: "",
        manufacturer: "",
        jan: "",
        category: "",
        title: "",
        genre1: "",
        genre2: ""
    });

    const [showForm, setShowForm] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await apiRequest("inventory/add_product/", "POST", formData);
            showAlert("商品が登録されました！");
            setFormData({
                item_name: "",
                sku: "",
                manufacturer: "",
                jan: "",
                category: "",
                title: "",
                genre1: "",
                genre2: ""
            });
            setShowForm(false);
        } catch (error) {
            showAlert("エラーが発生しました：" + error.message);
        }
    };

    return (
        <div className="AddProductForm_container">
            <button className="AddProductForm_toggleButton" onClick={() => setShowForm(!showForm)}>
                {showForm ? "フォームを閉じる" : "新規商品を追加"}
            </button>

            {showForm && (
                <form onSubmit={handleSubmit}>
                    <div className="AddProductForm_record">
                        <input type="text" className="AddProductForm_item_name" name="item_name" placeholder="商品名" value={formData.item_name} onChange={handleChange} />
                        <input type="text" className="AddProductForm_sku" name="sku" placeholder="SKU" value={formData.sku} onChange={handleChange} />
                        <input type="text" className="AddProductForm_manufacturer" name="manufacturer" placeholder="メーカー" value={formData.manufacturer} onChange={handleChange} />
                        <input type="text" className="AddProductForm_jan" name="jan" placeholder="JAN" value={formData.jan} onChange={handleChange} />
                        <input type="text" className="AddProductForm_category" name="category" placeholder="カテゴリー" value={formData.category} onChange={handleChange} />
                        <input type="text" className="AddProductForm_title" name="title" placeholder="作品名" value={formData.title} onChange={handleChange} />
                        <input type="text" className="AddProductForm_genre1" name="genre1" placeholder="ジャンル1" value={formData.genre1} onChange={handleChange} />
                        <input type="text" className="AddProductForm_genre2" name="genre2" placeholder="ジャンル2" value={formData.genre2} onChange={handleChange} />
                        <button type="submit" className="AddProductForm_submit">登録</button>
                    </div>
                </form>
            )}
        </div>
    );
}

export default AddProductForm;
